module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pendenciasFiltradas), function(p) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-6 hover-items"
    }, [_c('div', {
      staticClass: "panel wrapper"
    }, [_c('h1', {
      staticClass: "m-t-none"
    }, [_vm._v("Lote " + _vm._s(p.numero))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none"
    }, [_vm._v("Valor Venda: R$ " + _vm._s(_vm._f("moeda")(p.valor)))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none small"
    }, [_vm._v("Valor Inicial: R$ " + _vm._s(_vm._f("moeda")(p.valorInicial)))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none small"
    }, [_vm._v(_vm._s(p.nome))]), _vm._v(" "), _c('h4', {
      staticClass: "m-t-none small"
    }, [_vm._v(_vm._s(p.apelido))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": '/#/website/arrematantes/' + p.arrematanteId,
        "target": "_blank"
      }
    }, [(p.tipo === 1) ? _c('span', {
      staticClass: "btn btn-black btn-lg font-bold"
    }, [_vm._v("CPF: " + _vm._s(_vm._f("formataCpf")(p.cpf)))]) : _c('span', {
      staticClass: "btn btn-black btn-lg font-bold"
    }, [_vm._v("CNPJ: " + _vm._s(_vm._f("formataCnpj")(p.cnpj)))])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary pull-right",
      on: {
        "click": function($event) {
          return _vm.visualizar(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye m-r-xs"
    }), _vm._v(" Visualizei")])])])
  }), 0), _vm._v(" "), (!_vm.pendencias || _vm.pendenciasFiltradas.length === 0) ? _c('div', [_vm._v("\n      Nenhuma interação necessária até o momento\n    ")]) : _vm._e(), _vm._v(" "), (_vm.pendencias && _vm.pendencias.length > 0 && _vm.pendencias.length !== _vm.pendenciasFiltradas.length) ? _c('div', {
    staticClass: "m-t"
  }, [_c('div', {
    staticClass: "m-b-xs"
  }, [_vm._v("Você ocultou algumas pendencias por tê-las visualizado.")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.pendenciasVisualizadas = []
      }
    }
  }, [_vm._v("Reativar pendencias ocultadas")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49e2e776","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/MonitorVendasOnline.vue
// module id = 773
// module chunks = 2